{
	"page": {
		"title": "Поиск",
		"subtitle": "По всему StudyHub: материалам, конспектам, карточкам, тестам",
		"placeholder": "Найди материал, конспект, карточку…",
		"controls": {
			"semantic": "Семантический",
			"semanticHint": "Понимает смысл, не только слова",
			"clear": "Очистить",
			"filters": "Фильтры"
		}
	},
	"tabs": {
		"all": "Все",
		"materials": "Материалы",
		"collections": "Папки",
		"notes": "Конспекты",
		"flashcards": "Карточки",
		"quizzes": "Тесты",
		"chats": "Чаты",
		"topics": "Темы"
	},
	"groups": {
		"materials": "Материалы",
		"collections": "Папки",
		"notes": "Конспекты",
		"flashcards": "Карточки",
		"quizzes": "Тесты",
		"chats": "Чаты",
		"actions": "Действия",
		"recents": "Недавние запросы",
		"viewAll": "Все",
		"topics": "Темы курса"
	},
	"empty": {
		"initial": {
			"title": "Что хочешь найти?",
			"hint": "Введи запрос или нажми Tab для команд",
			"popular": "Часто ищут",
			"popularQueries": [
				"митохондрии",
				"фотосинтез",
				"производная",
				"ЕГЭ",
				"Кребс"
			],
			"recents": "Недавние"
		},
		"zero": {
			"title": "Ничего не нашлось",
			"subtitle": "Попробуй другие слова или включи семантический поиск",
			"suggestion": "Часто помогает уточнить тему или язык"
		},
		"offline": {
			"title": "Для поиска требуется подключение",
			"subtitle": "Глобальный поиск работает онлайн. Проверьте подключение к сети и повторите попытку."
		}
	},
	"loading": "Ищем…",
	"error": {
		"title": "Не удалось выполнить поиск",
		"hint": "Проверь подключение и попробуй ещё раз",
		"retry": "Повторить"
	},
	"filters": {
		"title": "Фильтры",
		"reset": "Сбросить",
		"language": "Язык",
		"tags": "Теги",
		"sourceType": "Тип источника",
		"material": "Материал",
		"set": "Папка"
	},
	"result": {
		"pages": "{count, plural, one {# страница} few {# страницы} other {# страниц}}",
		"openedAt": "Открыто {when}",
		"loadMore": "Загрузить ещё",
		"showing": "Показано {from}–{to} из {total}"
	}
}
